var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_511_3410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.91536 0.964962C5.17096 0.0966506 6.40527 0.0966504 6.66087 0.964962C6.83432 1.55422 7.53511 1.80322 8.03908 1.45205C8.75374 0.954062 9.6883 1.66096 9.4036 2.48417L9.27864 2.84551C9.0768 3.42913 9.44695 4.05438 10.0557 4.15814L10.103 4.16619C11.0114 4.32102 11.2446 5.51789 10.4608 6.00252L10.2657 6.1232C9.76005 6.43583 9.63719 7.11788 10.0019 7.58729L10.2419 7.89611C10.7887 8.59996 10.1491 9.60074 9.28067 9.40001C8.67846 9.26083 8.10646 9.72641 8.1205 10.3443L8.12609 10.59C8.14601 11.4666 7.01677 11.8365 6.51418 11.118C6.16146 10.6137 5.41477 10.6137 5.06205 11.118C4.55946 11.8365 3.43022 11.4666 3.45014 10.59L3.45573 10.3443C3.46977 9.72641 2.89777 9.26083 2.29556 9.40001C1.42712 9.60074 0.787495 8.59996 1.33437 7.89611L1.57432 7.58729C1.93904 7.11788 1.81618 6.43583 1.31057 6.1232L1.11538 6.00252C0.331606 5.51789 0.56487 4.32102 1.47328 4.16619L1.52053 4.15814C2.12928 4.05438 2.49943 3.42913 2.29759 2.84551L2.17263 2.48417C1.88793 1.66096 2.82249 0.954062 3.53715 1.45205C4.04112 1.80322 4.74191 1.55422 4.91536 0.964962Z",
    fill: "#14BE6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5464 5L5.12973 8L4.03125 6.63636",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_511_3410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5455,
    height: 12,
    fill: "white",
    transform: "translate(0.515625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckNew);
export default __webpack_public_path__ + "static/media/check-new.0694443e92e27d611486f6fdb35068d8.svg";
export { ForwardRef as ReactComponent };